import {
  Section,
  Hero,
  IntroMarkup,
  QuiltedList,
} from '@components';
import { DefaultLayout } from '@layouts';
import { NextSeo } from 'next-seo';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { stringify } from 'qs';

export default function CuisinePage({ data }) {
  const { hero, introduction, seo, gallery } = data;

  return (
    <>
      <NextSeo
        title={`Momento | ${seo?.metaTitle}`}
        description={seo?.metaDescription}
      />
      <DefaultLayout
        showBookingCta={false}
        className="pb-20 mb-0"
        header={
          <Hero
            isHero
            cta={null}
            hasSlider={false}
            label={hero?.label}
            title={hero?.title}
            description={hero?.description}
            img={hero?.media?.data?.[0]?.attributes}
          />
        }
      >
        <Section className={'mb-0 pb-0'}>
          <IntroMarkup
            text={introduction}
            className={'md:columns-2'}
          />

          <QuiltedList gallery={gallery?.data} />
        </Section>
      </DefaultLayout>
    </>
  );
}

export async function getServerSideProps({ res, locale }) {
  const path = process.env.NEXT_PUBLIC_STRAPI; // process.env.NEXT_PUBLIC_STRAPI;
  const lang = `locale=${locale}`;

  const populateCuisinePage = stringify(
    {
      populate: ['hero', 'hero.media', 'seo', 'gallery'],
    },
    { encodeValuesOnly: true },
  );

  // CuisinePage Data
  const getCuisinePage = await fetch(
    `${path}/cuisine-page?populate=${populateCuisinePage}&${lang}`,
  );
  const philosophyPage = await getCuisinePage?.json();

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      data: philosophyPage?.data?.attributes || {},
    },
  };
}
